import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';
import PhaseAnimation from '../components/PhaseAnimation';
import { IconCheck } from '../components/Icons';
import '../components/phases.css';

const IconDownload = ({ size = 13 }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12M7 11l5 5 5-5M5 21h14" /></svg>);

const FASE_LABEL = {
  avvio: 'Avvio verifica…',
  registrazione: 'Chiamata al 456 e registrazione…',
  trascrizione: 'Trascrizione della risposta…',
  attesa: 'Attesa tra le varianti…',
  analisi: "Analisi dell'esito…",
  gea: 'Verifica Vodafone…',
};
const esitoLabel = (r) => (r === 'SERVIZIO_NON_DISPONIBILE' ? 'Servizio non disp.' : (r || '—'));
const esitoVar = (r) => (r === 'NON TIM' ? 'var(--ok)' : r === 'TIM' ? 'var(--signal)' : 'var(--alert)');
const geaLabel = (r) => (r === 'VODAFONE' ? 'Vodafone' : r === 'NEGATIVO' ? 'Non Vodafone'
  : r === 'DISSERVIZIO' ? 'Servizio non disponibile' : r === 'ERRORE' ? 'Errore' : (r || '—'));

export default function VerificaResult({ job }) {
  const running = job.stato === 'in_corso';
  const e = job.e456;
  const g = job.gea;

  const scarica = async () => {
    try {
      const r = await axios.get(`${API}/verifica-multi/${job.id}/registrazione`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = `verifica_${job.numero}.mp3`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Registrazione scaricata');
    } catch { toast.error('Registrazione non disponibile'); }
  };

  if (running) {
    return (
      <>
        <div className="m-anim"><PhaseAnimation fase={job.fase === 'gea' ? 'analisi' : (job.fase || 'avvio')} /></div>
        <div className="m-dialing">{FASE_LABEL[job.fase] || 'Verifica in corso…'}<span className="dots"><i /><i /><i /></span></div>
        <div className="m-sub" style={{ textAlign: 'center' }}>Puoi ridurre: la verifica continua in background.</div>
      </>
    );
  }

  return (
    <div className="m-result">
      <div className="rhead">
        <div className="rnum">{job.numero} · FISSO</div>
        <div className="rverd" style={{ color: esitoVar(e?.risultato) }}>{esitoLabel(e?.risultato)}</div>
        <div className="rsub">
          {e?.risultato === 'NON TIM' ? 'Operatore diverso da Telecom'
            : e?.risultato === 'TIM' ? (e?.numerazione_inattiva ? 'Numero Telecom · numerazione NON attiva' : 'Numero Telecom')
              : (e?.errore || 'Esito non conclusivo')}
        </div>
      </div>
      {e?.audio_file && (
        <div className="m-rrow">
          <div className="rx"><b>Registrazione della chiamata</b><span>risposta del 456</span></div>
          <button className="act" onClick={scarica} style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><IconDownload size={12} /> scarica</button>
        </div>
      )}
      {g && g.eseguita && (
        <div className="m-rrow">
          <span className="ri"><IconCheck size={13} /></span>
          <div className="rx"><b>Vodafone (GEA)</b><span>{geaLabel(g.risultato)}</span></div>
        </div>
      )}
      {g && !g.eseguita && (
        <div className="m-sub" style={{ marginTop: 8 }}>Vodafone non verificato ({g.motivo_saltata}).</div>
      )}
    </div>
  );
}
